const Spinner = () => (
    <svg
        width='93'
        height='95'
        viewBox='0 0 93 95'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M89.9083 71.0633C92.4837 73.1 92.9423 76.8668 90.6301 79.198C86.6571 83.2037 82.0608 86.5586 77.0083 89.1258C70.1846 92.593 62.6909 94.541 55.0426 94.836C47.3943 95.131 39.7728 93.7659 32.7024 90.8346C25.6319 87.9033 19.2803 83.4754 14.0842 77.8553C8.88816 72.2353 4.97102 65.5565 2.6022 58.2783C0.233377 51 -0.530931 43.2951 0.361849 35.6933C1.25463 28.0916 3.78332 20.7734 7.77399 14.242C10.7288 9.40606 14.4332 5.08643 18.7376 1.4392C21.2427 -0.683439 24.962 0.068636 26.7909 2.79561C28.6197 5.52259 27.8558 9.18684 25.4209 11.3896C22.5076 14.0252 19.9794 17.0718 17.9204 20.4415C14.825 25.5076 12.8637 31.184 12.1712 37.0803C11.4787 42.9766 12.0715 48.9529 13.9089 54.5983C15.7463 60.2436 18.7846 65.4241 22.8149 69.7833C26.8453 74.1424 31.7719 77.577 37.2561 79.8506C42.7404 82.1243 48.6519 83.1831 54.5844 82.9543C60.5168 82.7256 66.3293 81.2145 71.6221 78.5252C75.1427 76.7364 78.3778 74.4544 81.2334 71.7563C83.62 69.5013 87.3328 69.0266 89.9083 71.0633Z'
            fill='url(#paint0_linear_223_1232)'
        />
        <defs>
            <linearGradient
                id='paint0_linear_223_1232'
                x1='21.8658'
                y1='7.69172'
                x2='83.3184'
                y2='76.6886'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='1' stopColor='#00FFFF' />
            </linearGradient>
        </defs>
    </svg>
);

export default Spinner;
